// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { AttentionCount } from './attentionCount.zod.ts';

export const Attention = zod.object({
  "denied_events": zod.int(),
  "failed_events": zod.int(),
  "failed_research": AttentionCount,
  "failed_sign_ins": zod.int(),
  "new_feedback": AttentionCount,
  "pending_industries": AttentionCount,
  "refused_runs": zod.int(),
  "stale_jobs": zod.int()
});

export type Attention = zod.input<typeof Attention>;
export type AttentionOutput = zod.output<typeof Attention>;
